import { FormattedMessage, useIntl } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import { PackingItemList } from '../packing-item-list/packing-item-list';
import { messages } from '../../messages';
import { aggregateItemPositions } from '../../utils/aggregate-item-positions';
import { formatPackageDimensions } from '../../utils/format-package-dimensions';
import style from './packing-package-list.module.css';
import type { BoxResult } from '../../types';

type PackingPackageListProps = {
  boxes: BoxResult[];
  sellerDimensionUnit: string;
};

export const PackingPackageList = ({ boxes, sellerDimensionUnit }: PackingPackageListProps) => {
  const intl = useIntl();

  return (
    <FlexColumn gap={Gap.Space8}>
      {boxes.map((boxResult, idx) => {
        const dims = formatPackageDimensions(boxResult.box, sellerDimensionUnit, intl);
        return (
          <FlexColumn key={`${boxResult.box?.name ?? 'box'}-${idx}`} gap={Gap.Space4}>
            <Text
              className={style.packageTitle}
              textType={TextType.Label}
              value={
                <>
                  <FormattedMessage {...messages.packageTitle} values={{ number: idx + 1, packageName: boxResult.box?.name ?? '' }} />
                  {dims && <span className={style.packageDims}>{` (${dims})`}</span>}
                </>
              }
            />
            <PackingItemList items={aggregateItemPositions(boxResult.itemPositions)} />
          </FlexColumn>
        );
      })}
    </FlexColumn>
  );
};
